import { render, staticRenderFns } from "./PointBasicSettingTop.vue?vue&type=template&id=50b5bb7d&"
import script from "./PointBasicSettingTop.vue?vue&type=script&lang=js&"
export * from "./PointBasicSettingTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports